/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointFreezeActionReqVo
 */
export interface UserPointFreezeActionReqVo {
    /**
     * 用户积分数据编号
     * @type {number}
     * @memberof UserPointFreezeActionReqVo
     */
    id: number;
    /**
     * 冻结/解冻的积分数量
     * @type {number}
     * @memberof UserPointFreezeActionReqVo
     */
    amount: number;
}

/**
 * Check if a given object implements the UserPointFreezeActionReqVo interface.
 */
export function instanceOfUserPointFreezeActionReqVo(value: object): value is UserPointFreezeActionReqVo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UserPointFreezeActionReqVoFromJSON(json: any): UserPointFreezeActionReqVo {
    return UserPointFreezeActionReqVoFromJSONTyped(json, false);
}

export function UserPointFreezeActionReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointFreezeActionReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'amount': json['amount'],
    };
}

export function UserPointFreezeActionReqVoToJSON(json: any): UserPointFreezeActionReqVo {
    return UserPointFreezeActionReqVoToJSONTyped(json, false);
}

export function UserPointFreezeActionReqVoToJSONTyped(value?: UserPointFreezeActionReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
    };
}

